import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/home.vue'),
    meta: {
      title: '盛世行',
    },
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/about.vue'),
    meta: {
      title: '公司简介',
    },
  },
  {
    path: '/productDisplay',
    name: 'productDisplay',
    component: () => import('../views/productDisplay.vue'),
    meta: {
      title: '产品展示',
    },
  },
  {
    path: '/recruit',
    name: 'recruit',
    component: () => import('../views/recruit.vue'),
    meta: {
      title: '人才招聘',
    },
  },
  {
    path: '/corporateCulture',
    name: 'corporateCulture',
    component: () => import('../views/corporateCulture.vue'),
    meta: {
      title: '企业文化',
    },
  },
  {
   
    path: '/searchResults',
    name: 'searchResults',
    component: () => import('../views/searchResults.vue'),
    meta: {
      title: '搜索结果',
    },
  },
  {
     path: '/contact',
    name: 'contact',
    component: () => import('../views/contactWe.vue'),
    meta: {
      title: '联系我们',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});

export default router;
